import { render, staticRenderFns } from "./VideoProductDetailContainer.vue?vue&type=template&id=2b2882af&scoped=true&"
import script from "./VideoProductDetailContainer.vue?vue&type=script&lang=js&"
export * from "./VideoProductDetailContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2882af",
  null
  
)

export default component.exports